import Users from "./index";

export const userRoutes = () => [
  {
    path: "/:lang/admin/users",
    component: Users,
    layout: "admin",
    routeType: "admin",
    title: "User Management",
  },
];
